var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/no-namespace */
import React, { useEffect, createRef, useRef } from 'react';
const Accordion = (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return React.createElement("puk-accordion", Object.assign({}, props), children);
};
const AccordionItem = (_a) => {
    var { children, expanded, onToggle } = _a, props = __rest(_a, ["children", "expanded", "onToggle"]);
    const ref = createRef();
    const listenerSetted = useRef(false);
    useEffect(() => {
        const accordionItem = ref.current;
        if (accordionItem && !listenerSetted.current) {
            accordionItem.addEventListener('toggle', onToggle);
            listenerSetted.current = true;
        }
    }, [listenerSetted.current]);
    return (React.createElement("puk-accordion-item", Object.assign({}, props, { ref: ref, expanded: expanded }), children));
};
AccordionItem.defaultProps = {
    expanded: false,
    onToggle: () => { }
};
export { Accordion, AccordionItem };
